var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTowerPowerconnectionEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 17.8435V15.8435H5.6L7.575 9.26851C7.70833 8.83517 7.95417 8.48934 8.3125 8.23101C8.67083 7.97267 9.06667 7.84351 9.5 7.84351H12.5C12.9333 7.84351 13.3292 7.97267 13.6875 8.23101C14.0458 8.48934 14.2917 8.83517 14.425 9.26851L16.4 15.8435H18V17.8435H4ZM7.7 15.8435H14.3L12.5 9.84351H9.5L7.7 15.8435ZM10 5.84351V0.843506H12V5.84351H10ZM15.95 8.31851L14.525 6.89351L18.075 3.36851L19.475 4.76851L15.95 8.31851ZM17 12.8435V10.8435H22V12.8435H17ZM6.05 8.31851L2.525 4.76851L3.925 3.36851L7.475 6.89351L6.05 8.31851ZM0 12.8435V10.8435H5V12.8435H0Z",
    fill: "#FF0953"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTowerPowerconnectionEmergency);
export default __webpack_public_path__ + "static/media/tower_powerconnection_emergency.af3da00fe8c5ed8cc148a32862cdb2c3.svg";
export { ForwardRef as ReactComponent };